import api from '../../../../api.js'
import {handleResponseErrors} from '../../../services/processServerErrors.js'

const TIMEOUT_STATUSES = [408, 504, 524]

export default async function upload(values, fetchConf) {
  const { useAI, ...restValues } = values

  if (useAI) {
    return api.freelances.cv.uploadWithAI(restValues, fetchConf).catch(e => {
      if (e && TIMEOUT_STATUSES.includes(e.status)) throw e
      return handleResponseErrors(e)
    })
  }

  return api.freelances.cv.upload(restValues, fetchConf).catch(handleResponseErrors)
}
